import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { HiOutlineSearch } from 'react-icons/hi'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/store'
import Form from '../Form'
import FormItem from '../Form/FormItem'
import Button from '../General/Button'
import Datepicker from '../Inputs/Datepicker'
import InputText from '../Inputs/InputText'
import Select from '../Inputs/Select'
import Switch from '../Inputs/Switch'

const AdvancedPurchaseForm: React.FC<IAdvancedPurchaseForm> = ({
  onSubmit,
  onCancel,
}) => {
  const form = useForm()

  const [isRangeDate, setIsRangeDate] = useState<boolean>(false)

  const [isDateSelected, setIsDateSelected] = useState<boolean>(false)

  return (
    <Form
      onSubmit={(values) => onSubmit({ ...values, isRangeDate, isDateSelected })}
      form={form}
      classes="gap-x-2 p-2"
    >
      <HiOutlineSearch
        fontSize={25}
        className="text-primaryGray-400 col-span-1"
      />
      <label className="col-span-11 text-left dark:text-white text-darkere">
        Búsqueda avanzada
      </label>

      <FormItem
        name="providerBusinessName"
        classes="lg:col-span-6 col-span-12 flex items-end"
      >
        <InputText
          small
          label="Nombre de proveedor"
          maxLength={80}
          isUpperValue={false}
        />
      </FormItem>

      <FormItem name="providerDocument" classes="lg:col-span-6 col-span-12">
        <InputText
          small
          label="Número de documento"
          maxLength={80}
          isUpperValue={false}
        />
      </FormItem>

      <FormItem name="billCode" classes="lg:col-span-6 col-span-12">
        <InputText
          small
          label="Número de factura"
          maxLength={80}
          isUpperValue={false}
        />
      </FormItem>

      <FormItem
        name="paidOut"
        classes="lg:col-span-6 col-span-12 flex flex-row items-center justify-center"
      >
        {/* <InputText small label="Nombre" maxLength={80} isUpperValue={false} /> */}
        <Switch label="Pagado" forForm={true} />
      </FormItem>

      <FormItem name="description" classes="lg:col-span-6 col-span-12">
        <InputText
          small
          label="Descripción"
          maxLength={80}
          isUpperValue={false}
        />
      </FormItem>

      {/* <div className="lg:col-span-6 col-span-12 flex flex-row items-center justify-center">
        <Switch label="Rango de fecha" forForm={true} onChange={(v) => setIsRangeDate(v)} />
      </div> */}

      <div
        className="lg:col-span-6 col-span-12 row-start-5"
        onClick={() => setIsDateSelected(true)}
      >
        <FormItem
          name="fromDate"
          classes="lg:col-span-6 col-span-12 row-start-5"
        >
          <Datepicker label="Fecha desde" />
        </FormItem>
      </div>

      <div
        className="lg:col-span-6 col-span-12 row-start-5"
        onClick={() => setIsDateSelected(true)}
      >
        <FormItem name="toDate" classes="lg:col-span-6 col-span-12 row-start-5">
          <Datepicker label="Fecha hasta" />
        </FormItem>
      </div>

      {/* { !isRangeDate && (
        <FormItem name="date" classes="lg:col-span-6 col-span-12">
        <Datepicker label='Fecha' />
      </FormItem>
      )} */}

      <div className="col-span-12 flex space-x-2 mt-4 px-1 mt-3">
        <Button
          type="outline"
          classes="w-1/2 mr-4"
          onClick={() => onCancel()}
          htmlType="button"
        >
          Cancelar
        </Button>

        <Button type="primary" classes="w-1/2 mr-4" htmlType="submit">
          Buscar
        </Button>
      </div>
    </Form>
  )
}

interface IAdvancedPurchaseForm {
  onSubmit: (value) => void
  onCancel: () => void
}

export default AdvancedPurchaseForm
